<fgb-mobile-page-header [pageTitle]="'auction.page.title'" backButtonLink="/" />
<fgb-banner class="d-lg-block d-none" [title]="'auction.page.title' | translate" />

<div class="container mobile-container">
  <fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>

  <div class="mt-3">
    <fgbcl-auction-list></fgbcl-auction-list>
  </div>
</div>
